module.exports = __webpack_public_path__ + "static/media/icon-check.baf7481c.svg";